export const getUserInitials = (firstName: string, lastName: string, email?: string) => {
  let initials = ''
  if (firstName || lastName) {
    initials = firstName[0] + lastName[0]
  } else if (email) {
    initials = email[0]
  }
  return initials.toUpperCase()
}
